import { getQuery } from "./UdasWrapper";

export const getPermissions = async (tenant_id) => {
	let data = JSON.stringify({
		query: `query Permissions($tenant_id: String!) {
              permissions(tenant_id: $tenant_id) {
                id
                category
                created_by
                description
                name
                notes
                role_id
              }
            }`,
		variables: { tenant_id: tenant_id }
	});
	try {
		const response = await getQuery(data);
		const permissions = response?.permissions;

		return permissions;
	} catch (error) {
		if (/Error\s+502:/.test(error.message)) {
			console.log("Retrying to fetch: getPermissions");
		}

		console.log("error", error);
		return null;
	}
};
